export const emailDomain = (email = '') => (email.toLowerCase().split('@')[1] || '').trim();

export const isEmail = (v = '') =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim().toLowerCase());
